var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeTrendUpSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.04 6.81994L14.28 2.78994C12.71 1.68994 10.3 1.74994 8.78999 2.91994L3.77999 6.82994C2.77999 7.60994 1.98999 9.20994 1.98999 10.4699V17.3699C1.98999 19.9199 4.05999 21.9999 6.60999 21.9999H17.39C19.94 21.9999 22.01 19.9299 22.01 17.3799V10.5999C22.01 9.24994 21.14 7.58994 20.04 6.81994ZM16.88 13.3999C16.88 13.7899 16.57 14.0999 16.18 14.0999C15.79 14.0999 15.48 13.7899 15.48 13.3999V13.2199L12.76 15.9399C12.61 16.0899 12.41 16.1599 12.2 16.1399C12 16.1199 11.81 15.9999 11.7 15.8299L10.68 14.3099L8.29999 16.6899C8.15999 16.8299 7.98999 16.8899 7.80999 16.8899C7.62999 16.8899 7.44999 16.8199 7.31999 16.6899C7.04999 16.4199 7.04999 15.9799 7.31999 15.6999L10.3 12.7199C10.45 12.5699 10.65 12.4999 10.86 12.5199C11.07 12.5399 11.26 12.6499 11.37 12.8299L12.39 14.3499L14.5 12.2399H14.32C13.93 12.2399 13.62 11.9299 13.62 11.5399C13.62 11.1499 13.93 10.8399 14.32 10.8399H16.18C16.27 10.8399 16.36 10.8599 16.45 10.8899C16.62 10.9599 16.76 11.0999 16.83 11.2699C16.87 11.3599 16.88 11.4499 16.88 11.5399V13.3999Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeTrendUpSolid);
export default __webpack_public_path__ + "static/media/home-trend-up-solid.d6a64a4e58d70b771251558dcbdbd058.svg";
export { ForwardRef as ReactComponent };